export const GET_CAMERAS = 'GET_CAMERAS'
export const UPDATE_CAMERAS = 'UPDATE_CAMERAS'
export const CREATE_CAMERAS = 'CREATE_CAMERAS'

export const FETCH_CAMERAS_REQUEST = 'FETCH_CAMERAS_REQUEST'
export const FETCH_CAMERAS_SUCCESS = 'FETCH_CAMERAS_SUCCESS'
export const FETCH_CAMERAS_FAILURE = 'FETCH_CAMERAS_FAILURE'
export const FETCH_CAMERAS_CLEANUP = 'FETCH_CAMERAS_CLEANUP'
